module.exports = __webpack_public_path__ + "static/media/eye.0cdb5305.svg";